import { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { BICtoBankInfo } from '@shinetools/iban-bban-bic';
import { motion } from 'framer-motion';
import { printFormat } from 'iban';

import Text from 'components/_core/Text';

import { BankTransferRecipient } from '../../types';

type PartialBankTransferRecipient = Pick<
  BankTransferRecipient,
  'name' | 'iban' | 'swiftBic' | 'label'
>;

interface BeneficiaryDetailsProps {
  beneficiary?: PartialBankTransferRecipient;
}

const BeneficiaryDetails: FC<BeneficiaryDetailsProps> = ({
  beneficiary: beneficiary,
}) => {
  const bankName = beneficiary?.swiftBic
    ? BICtoBankInfo(beneficiary.swiftBic).name
    : '';

  const bankInfo = `${bankName ? `${bankName} • ` : ''}${
    beneficiary?.iban ? printFormat(beneficiary.iban) : '-'
  }`;

  return (
    <Flex direction="column" flexGrow={1}>
      <motion.div
        animate={{
          opacity: beneficiary ? 1 : 0,
          visibility: beneficiary ? 'inherit' : 'hidden',
          y: beneficiary ? 0 : 10,
        }}
      >
        <Text fontWeight="weight-500" variant="primary">
          {beneficiary?.label || beneficiary?.name || '-'}
        </Text>

        <Text size="sm" variant="secondary">
          {bankInfo}
        </Text>
      </motion.div>
    </Flex>
  );
};

export default BeneficiaryDetails;
